import api from './api';

export const getComments = async (documentId, params = {}) => {
  const response = await api.get(`/comments/document/${documentId}`, { params });
  return response.data;
};

export const createComment = async (documentId, content, type = 'comment', parentCommentId = null) => {
  const response = await api.post('/comments', {
    documentId,
    content,
    type,
    parentCommentId,
  });
  return response.data;
};

export const updateComment = async (id, content) => {
  const response = await api.put(`/comments/${id}`, { content });
  return response.data;
};

export const deleteComment = async (id) => {
  const response = await api.delete(`/comments/${id}`);
  return response.data;
};

export const addReaction = async (id, emoji) => {
  const response = await api.post(`/comments/${id}/reactions`, { emoji });
  return response.data;
};

export const removeReaction = async (id, emoji) => {
  const response = await api.delete(`/comments/${id}/reactions/${emoji}`);
  return response.data;
};